import { transition } from '@helpers/animate';
import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { ButtonReset } from '@helpers/global';
import { SiteWidth } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import { contentStyles, h1, paragraphLarge, tag } from '@helpers/typography';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
const Wrapper = styled(SectionWrapper) `
  padding: 1px 0;

  &[data-background='beige'] {
    background-color: ${brand.beige};
  }

  &[data-background='green'] {
    background-color: ${brand.green};
  }

  &[data-background='beige'],
  &[data-background='green'] {
    padding: calc(var(--sectionSpacing) * 0.5) 0;
  }

  &[data-background='white'] {
    background-color: ${brand.white};
    margin: var(--sectionSpacing) 0;
  }
`;
const Container = styled.div `
  --scSpacing: 24px;
  --scBackground: ${brand.green};
  --scColor: ${brand.white};

  &[data-variant='beige'] {
    --scBackground: ${brand.beige};
  }

  &[data-variant='white'] {
    --scBackground: ${brand.white};
  }

  &[data-variant='white'],
  &[data-variant='beige'] {
    --scColor: ${brand.black};
  }

  padding: var(--scSpacing);
  display: grid;
  gap: var(--scSpacing);
  position: relative;
  z-index: 1;
  max-width: calc(${SiteWidth}px + (var(--scSpacing) * 2));
  margin: 0 auto;

  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: -1;
    background-color: var(--scBackground);
  }

  @media ${from(Device.TabletMedium)} {
    --scSpacing: 52px;

    grid-template-columns: 1fr 1.75fr;
    gap: 24px var(--scSpacing);
    width: calc(75% + (var(--scSpacing) * 2));
    padding-top: calc(var(--scSpacing) * 0.66);
    padding-bottom: calc(var(--scSpacing) * 0.66);

    &[data-media-position='left'] {
      grid-template-columns: 1.75fr 1fr;

      &::before {
        left: 15%;
      }
    }

    &[data-media-position='right']::before {
      right: 15%;
    }
  }

  @media ${from(Device.DesktopLarge)} {
    --scSpacing: 104px;

    grid-template-columns: 1fr 2fr;
    padding-top: calc(var(--scSpacing) * 0.5);
    padding-bottom: calc(var(--scSpacing) * 0.5);

    &[data-media-position='left'] {
      grid-template-columns: 2fr 1fr;
    }
  }

  @media ${from(Device.ActualDesktop)} {
    grid-template-columns: 1fr 2.3fr;

    &[data-media-position='left'] {
      grid-template-columns: 2.3fr 1fr;
    }
  }
`;
const Title = styled.h2 `
  ${h1};

  margin-bottom: 0;
  color: var(--scColor);
`;
const SubTitle = styled.span `
  ${tag};

  color: var(--scColor);
`;
const ImageWrapper = styled.div `
  ${imageWrapperPreserveRatio(791, 534)};

  grid-row: span 2;
  align-self: center;

  @media ${from(Device.TabletMedium)} {
    [data-media-position='left'] & {
      order: -1;
    }

    height: 100%;
  }
`;
const Image = styled.img `
  ${imageCoverContainer()};
`;
const VideoButton = styled.button `
  ${ButtonReset};

  svg {
    position: absolute;
    color: ${brand.white};
    top: 50%;
    left: 50%;
    width: ${fluid(75, 105)};
    transform: translate(-50%, -50%);
    ${transition('opacity')};
    opacity: 0.7;
  }

  &:hover svg {
    opacity: 1;
  }
`;
const ContentWrapper = styled.div `
  margin-top: auto;
  color: var(--scColor);

  ${SectionWrapperStyles.Inner} {
    padding-left: 0;
    padding-right: 0;
  }
`;
const Content = styled.div `
  ${contentStyles};

  p:last-child {
    margin-bottom: 0;
  }
`;
const LinkWrapper = styled.span `
  ${paragraphLarge};
  margin: ${fluid(16, 24)} 0 0;
`;
const SplitContentStyles = {
    Container,
    Title,
    SubTitle,
    ImageWrapper,
    VideoButton,
    Image,
    ContentWrapper,
    Content,
    LinkWrapper,
    Wrapper,
};
export default SplitContentStyles;
